import { LOVE_LINES } from '@/mocks/celebrity';

export default function LoveLine() {
  return (
    <section id="love-line" className="bg-gradient-to-b from-background-100/60 to-background-50">
      <div className="mx-auto max-w-[1200px] px-4 py-14 md:px-6 md:py-20">
        <div className="mx-auto max-w-2xl text-center">
          <p className="text-xs font-semibold uppercase tracking-[0.22em] text-accent-600">
            RELATIONSHIP TIMELINE
          </p>
          <h2 className="mt-1 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
            感情线专题 · 一段恋爱的完整时间轴
          </h2>
          <p className="mt-3 text-sm leading-relaxed text-foreground-600">
            把综艺、动态与访谈里零散的线索，按时间整理成看得懂的恋爱时间线。从相识、暧昧到公开，每一步都标好依据。
          </p>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-6 lg:grid-cols-2">
          {LOVE_LINES.map((line) => (
            <div
              key={line.celeb}
              className="rounded-2xl border border-background-200 bg-background-50 p-5 md:p-7"
            >
              <div className="flex flex-wrap items-center justify-between gap-3 border-b border-background-200 pb-4">
                <div>
                  <p className="text-xs text-foreground-500">{line.coverLabel}</p>
                  <h3 className="mt-1 font-heading text-lg font-bold text-foreground-950 md:text-xl">
                    {line.celeb}
                  </h3>
                </div>
                <div className="flex items-center gap-2">
                  <span className="rounded-full bg-primary-100 px-3 py-1 text-xs font-medium text-primary-700">
                    {line.status}
                  </span>
                  <span className="rounded-full bg-secondary-100 px-3 py-1 text-xs text-secondary-700">
                    相恋 {line.totalYears}
                  </span>
                </div>
              </div>

              <ol className="mt-5 space-y-0">
                {line.events.map((ev, idx) => (
                  <li key={ev.time} className="relative flex gap-4 pb-5 last:pb-0">
                    {idx < line.events.length - 1 && (
                      <span className="absolute left-[5px] top-5 h-full w-px bg-background-300" />
                    )}
                    <span
                      className={`relative mt-1 h-2.5 w-2.5 shrink-0 rounded-full ${
                        idx === line.events.length - 1 ? 'bg-primary-500' : 'bg-accent-500'
                      }`}
                    />
                    <div>
                      <p className="text-xs font-semibold text-accent-700">{ev.time}</p>
                      <p className="mt-0.5 text-sm leading-6 text-foreground-800">{ev.text}</p>
                    </div>
                  </li>
                ))}
              </ol>

              <p className="mt-4 border-t border-background-200 pt-3 text-xs text-foreground-500">
                <i className="ri-information-line mr-1 text-accent-600" />
                时间点均来自公开可查物料，当事人澄清后会第一时间更新备注。
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}